import { createContext } from 'react';

const initialContextState = {
    addresses: [],
    total: 0,
};
const AddressListContext = createContext(initialContextState);
const initialAddressActions = {
    addNewDeliveryAddress: () => { },
    editDeliveryAddress: () => { },
    showSavedAddresses: () => { },
    editInvoiceAddress: () => { },
    discardChanges: () => { },
    scrollToTop: () => { },
};
const AddressActionsContext = createContext(initialAddressActions);

export { AddressActionsContext, AddressListContext, initialAddressActions, initialContextState };
//# sourceMappingURL=address-context.js.map
